import { JumpstartSpinCommand } from "slotworks/commands/comms/jumpstart-spin-command";
import Recover from "slotworks/state-machine/standard/states/recover";

export default class RecoverSpin extends Recover {
    public onEnter() {
        JumpstartSpinCommand().execute();

        super.onEnter();
    }
}
